import { render, staticRenderFns } from "./PortfolioImage.vue?vue&type=template&id=41b1eef6"
import script from "./PortfolioImage.vue?vue&type=script&lang=js"
export * from "./PortfolioImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports